import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import { Link } from 'react-router-dom'

export const APArticleContainer = styled.div`
  width: 100%;
  max-width: 680px;
  margin: 100px auto;
  background: #fff;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  font-family: Outfit;
`

// export const StyledSkeleton = muiStyled(Skeleton)(({ theme }) => ``)

export const APArticleHeading = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
  text-align: left;
  color: #000;
  @media (min-width: 768px) {
    font-size: 38px;
    line-height: 44px;
  }
`

export const APArticleDescription = styled.div`
  font-size: 15px;
  margin-top: 12px;
  margin-bottom: 24px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #6b6b6b;
  font-style: italic;
  @media (min-width: 768px) {
    font-size: 18px;
    margin-top: 15px;
    line-height: 28px;
  }
`

export const APShortDetailsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const APMoreDetailsSection = styled.div`
  display: flex;
  gap: 20px;
  padding: 32px 0 24px 0;
  color: #0c0c0c;
  font-size: 16px;
  border-top: 1px dashed #000000;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`

export const APCreatorImage = styled.img`
  width: ${(props) => (props?.big ? '64px' : '44px')};
  height: ${(props) => (props?.big ? '64px' : '44px')};
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  @media (min-width: 768px) {
    width: ${(props) => (props?.big ? '72px' : '44px')};
    height: ${(props) => (props?.big ? '72px' : '44px')};
  }
`

export const APShortDetailsText = styled.div`
  font-size: ${(props) => (props?.big ? '16px' : '14px')};
  color: ${(props) => (props?.big ? '#242424' : '#6B6B6B')};
`

export const APArticleMainImage = styled.img`
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 30px 0;
`

export const APArticleTextContainer = styled.div`
  position: relative;
  width: 100%;
  ${(props) => props?.premium && 'height: 300px; overflow: hidden;'};
  color: #242424;
  font-size: 1rem; /* Equivalent to 16px */
  p {
    font-size: 1rem;
    strong {
      font-weight: 500;
    }
  }
  h1 {
    font-size: 1.375rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
    line-height: 1.2;
  }
  h2 {
    font-size: 1.325rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  h3 {
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  h4 {
    font-size: 1.275rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  h5 {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  h6 {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  img {
    margin: auto;
    border: 1px solid #f4f4f4;
  }
  a {
    font-size: 1rem;
  }
  img {
    width: 100%;
  }
  blockquote {
    font-size: 1rem;
    margin-bottom: 1rem;
    padding-left: 5px;
  }
  ol {
    list-style-type: decimal;
    padding-left: 20px;
    margin: 16px 0;
  }
  ul {
    list-style-type: disc;
    padding-left: 20px;
    margin: 16px 0;
  }
  li {
    font-size: 1rem;
  }
  a {
    color: #2819af;
    text-decoration: underline;
  }

  @media (min-width: 1200px) {
    font-size: 1rem;
    p {
      strong {
        font-weight: 500;
      }
    }
    h1 {
      font-size: 2.5rem;
      font-weight: 500;
      margin-bottom: 0.5rem;
      line-height: 1.2;
    }
    h2 {
      font-size: 2rem;
      font-weight: 500;
      line-height: 1.2;
      margin-bottom: 0.5rem;
    }
    h3 {
      font-size: 1.75rem;
      font-weight: 500;
      line-height: 1.2;
      margin-bottom: 0.5rem;
    }
    h4 {
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 1.2;
      margin-bottom: 0.5rem;
    }
  }
`

export const APRelatedArticlesSeparator = styled.div`
  width: 100%;
  height: 2px;
  background: #000;
  margin: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const APRelatedArticleTitle = styled.div`
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`

export const RelatedArticlesHeading = styled(Link)`
  font-weight: 600;
  font-size: 18px;
  color: #000;
`

export const APRelatedArticleContainer = muiStyled('div')(
  ({ theme }) => `
display: flex;
justify-content: center;
flex-wrap: wrap;
gap: 10px;
padding: 25px 0px;
.___article_layout_card_container {
  max-width: 576px;
  @media(min-width: 576px){
    max-width: calc(50% - 15px);
  }
}
._mentor-card-portrait-single-card-container_ {
  flex: unset;
  width: 100%;
  max-width: 576px;
  @media (min-width: 768px){
    max-width: calc(50% - 15px);
  }
}
._square-mid-card-single-card-container_{
  flex: unset;
  width: 100%;
  max-width: 576px;
  @media (min-width: 768px){
    max-width: calc(50% - 15px);
  }
}
`,
)

export const ArticleContentBlur = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background: linear-gradient(to bottom, transparent 0%, white 40%, white 100%);
`
